<template>
  <v-container tag="section">
    <material-wizard
      :title="title"
      subtitle="Preencha as Informações para gerar seu comparativo."
      v-model="tab"
      :available-steps="availableSteps"
      :tabs="tabs"
      class="mx-auto"
      @click:next="next(1)"
      @click:prev="tab--"
      :disabledBtnFinalizar="validTabs[tab+1] === false"
      :loading="loading"
      btnSaveCustomId="btn-save-comparativo"
    >
      <sig-r-wizzard-tabs 
        ref="sigRParametros" 
        :items="comparativo" 
        :tucs="tucs"
        @secondStepAvailable="validTabs[1] = $event"
        @thirdStepAvailable="validTabs[2] = $event"
        @btnFinishAvailable="validTabs[3] = $event"
      />
    </material-wizard>
  </v-container>
</template>

<script>
import SigRComparaService from '@/services/SigRComparaService';
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [tourMixins],

  components: {
    SigRWizzardTabs: () => import('@/components/sigRCompara/sigRWizzardTabs'),
    MaterialWizard: () => import('@/components/base/MaterialWizard'),
  },

  mounted() {
    if (this.$route.params.id) {
      this.getComparativo(this.$route.params.id);
    };
    
   
    this.iniciarPrimeiraTabTour();  
  },

  data() {
    return {
      typeTourSecondTab: 'banco de dados', /* 'banco de dados' || 'arquivo' || 'apenas bdgd' */
      tab: 0,
      tabs: ["Início", "Origem & Tipo", "Tucs & Odis"],
      validTabs: {0: true, 1: false, 2: false, 3: undefined},
      availableSteps: [0],
      comparativo: {},
      tucs: [],
      loading: false,
      arrTourPrimeiraTab: [
        {
          element: '#titulo-comparativo',
          intro: 'Aqui você poderá inserir um nome para o seu comparativo.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#data-imobilizacao-comparativo',
          intro: 'Esses campos são opcionais e devem ser preenchido caso você queira um resultado mais específico para seu comparativo, determinando intervalos de data de imobilização.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#group-check-comparativo',
          intro: 'Aqui você poderá adicionar filtros ao seu comparativo, definindo o que será comparado.',
          scrollTo: "tooltip",
          position: 'right'
        },
      ],
      arrTourTerceiraTab: [
        {
          element: "#tucs-comparativo",
          intro: 'Aqui você poderá selecionar as TUCs que irão compor o resultado de seu comparativo.',
          scrollTo: "tooltip",
          position: "left"
        },
        {
          element: "#odis-comparativo",
          intro: "Aqui você poderá inserir códigos de ODIs, caso queira um resultado mais específico para seu comparativo.",
          scrollTo: "tooltip",
          position: "top"
        },
        {
          element: '#btn-save-comparativo',
          intro: 'Após seleção dos critérios anteriores clique aqui para salvar e executar o comparativo.',
          scrollTo: "tooltip",
          position: 'left'
        },
      ],
    }
  },

  methods: {
    next(valid) {
      if (!valid) return;

      if (this.tab === this.tabs.length - 1) {
        this.salvarComparativo()
      } else {
        this.tab++;
      }
    },

    getComparativo(id) {
      SigRComparaService.getComparativo(id).then(response => {
        this.availableSteps = [0, 1, 2, 3];
        this.validTabs = {0: true, 1: true, 2: true, 3: true};
        this.comparativo = response.data.comparativo;
        this.tucs = response.data.tucs;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar comparativo.', '',{position:'topRight'});
      });
    },

    salvarComparativo() {
      const data = this.$refs.sigRParametros.exportData();
      const id = !this.$route.params.id ? null : this.$route.params.id;
      this.loading = true;

      SigRComparaService.salvarComparativo(data, id).then(() => {
        this.$toast.success('Comparativo salvo com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'SIG-R Compara Histórico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar comparativo.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },

    iniciarPrimeiraTabTour() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;
     
      let onBeforeExitFunction = {
          func: (() => {
            this.tab = 1;
            this.initTourSegundaTab();
          })
        };
      
      this.iniciarTour(this.arrTourPrimeiraTab, [], [], [onBeforeExitFunction]);
    },

    initTourSegundaTab() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
          func: (() =>{
            this.tab = 2;
            this.initTourTerceiraTab();
          })
      };
      
      this.iniciarTour(this.arrTourSegundaTab, [], [], [onBeforeExitFunction]);
    },

    initTourTerceiraTab() {
      this.doneLabel = 'Finalizar';
      this.desativarTourAoSair = true;
      
      let onBeforeExitFunction = {
          func: (() =>this.tab = 0)
        };
    
      this.iniciarTour(this.arrTourTerceiraTab, [], [], [onBeforeExitFunction]);
    },
  },

  computed: {
    title() {
      return this.$route.params.id ? `Editando Comparativo` : 'Adicionar Novo Comparativo';
    },

    stepsProps() {
      return `${this.validTabs[0]}|${this.validTabs[1]}|${this.validTabs[2]}`;
    },

    arrTourSegundaTab() {
      let typeTour = this.$refs.sigRParametros.exportTypeTour();

      if (typeTour == 'apenas bdgd') {
        return [
          {
            element: "#group-tipo-comparativo",
            intro: "Aqui você poderá optar entre a verificação completa (físico x contábil) ou apenas uma verificação da BDGD (físico).",
            scrollTo: "tooltip",
            position: "bottom"
          },
          {
            element: "#data-base-bdgd-ais-comparativo",
            intro: "Aqui você poderá inserir a data base da BDGD.",
            scrollTo: "tooltip",
            position: "top"
          },
        ];
      } else if (typeTour == 'banco de dados') {
        return [
          {
            element: "#group-tipo-comparativo",
            intro: "Aqui você poderá optar entre a verificação completa (físico x contábil) ou apenas uma verificação da BDGD (físico).",
            scrollTo: "tooltip",
            position: "bottom"
          },
          {
            element: "#origem-ais-comparativo",
            intro: "Aqui você poderá selecionar a origem ais de seu comparativo 'Banco de dados' ou 'Arquivo'.",
            scrollTo: "tooltip",
            position: "top"
          },
          {
            element: "#data-base-bdgd-ais-comparativo",
            intro: "Aqui você poderá inserir a data base da BDGD e AIS.",
            scrollTo: "tooltip",
            position: "top"
          }
        ];
      } else {
        return [
          {
            element: "#group-tipo-comparativo",
            intro: "Aqui você poderá optar entre a verificação completa (físico x contábil) ou apenas uma verificação da BDGD (físico).",
            scrollTo: "tooltip",
            position: "bottom"
          },
          {
            element: "#origem-ais-comparativo",
            intro: "Aqui você poderá selecionar a origem ais de seu comparativo 'Banco de dados' ou 'Arquivo'.",
            scrollTo: "tooltip",
            position: "top"
          },
          {
            element: "#csv-ais-comparativo",
            intro: "Aqui você poderá selecionar um arquivo csv para compor a base AIS a ser comparada e determinar as configurações do arquivo (delimitador, invólucro e escape).",
            scrollTo: "tooltip",
            position: "top"
          },
          {
            element: "#data-base-bdgd-ais-comparativo",
            intro: "Aqui você poderá inserir a data base da BDGD.",
            scrollTo: "tooltip",
            position: "top"
          },
        ];
      }
    }
  },

  watch: {
    stepsProps() {
      for (let i = 1; i <= 3; i++) {
        (this.validTabs[i] && this.validTabs[i-1]) 
          ? this.availableSteps.push(i) 
          : this.availableSteps = this.availableSteps.filter(key => key != i);
      }
      if (this.validTabs[2] && this.validTabs[3] == undefined) this.availableSteps.push(3);
    }
  }
}
</script>

<style scoped>
  .divisor-picker {
    margin-bottom: 8px;
  }
</style>